import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { USERCREDENTIALS } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
const BaseDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const UserCredentialDataTable = DataTableHoc(BaseDataTable);

/**
 * User Credentials main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The User Credentials component.
 */
const UserCredentials = ({ integrationConnection }) => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto k-px-4'>
        <React.Suspense fallback={<Loader />}>
          <UserCredentialDataTable
            integrationConnection={integrationConnection}
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={USERCREDENTIALS}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={USERCREDENTIALS}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${USERCREDENTIALS}.DataGrid.RowLayout`}
            pageLengthConfigName={`${USERCREDENTIALS}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            initialSort={{
              field: 'id',
              dir: 'desc',
            }}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default UserCredentials;
